export default "<div id=\"navi\">\n   <toggle-navigation></toggle-navigation>\n   <zoom [useViewerZoom]=\"false\"></zoom>\n</div>\n"